import firebase from "firebase";

// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
    apiKey: "AIzaSyC-pDXzGrCo-PuV2q-Yzv0cfUJ0dJEzd4M",
    authDomain: "ichatbeta.firebaseapp.com",
    databaseURL: "https://ichatbeta.firebaseio.com",
    projectId: "ichatbeta",
    storageBucket: "ichatbeta.appspot.com",
    messagingSenderId: "328752319229",
    appId: "1:328752319229:web:05c7394e4e7914adf04c94",
    measurementId: "G-062EXCV5WJ"
};

const firebaseApp = firebase.initializeApp(firebaseConfig);
const db = firebaseApp.firestore();
const auth = firebase.auth();
const provider = new firebase.auth.GoogleAuthProvider();

export { auth, provider };
export default db;
